import React, {
  createContext,
  useContext,
  useEffect,
  useReducer,
} from "react";

import defaultSettings from "./defaultSettings";
import accessibilityReducer, {
  ACTIONS,
} from "./accessibilityReducer";

import {
  loadSettings,
  saveSettings,
} from "./storage";

import applyTheme from "./ThemeEngine";
import applyTypography from "./FontEngine";

const AccessibilityContext = createContext();

export const AccessibilityProvider = ({ children }) => {
  const [settings, dispatch] = useReducer(
    accessibilityReducer,
    defaultSettings,
    () => loadSettings() || defaultSettings
  );

  useEffect(() => {
    saveSettings(settings);

    applyTheme(settings);

    applyTypography(settings);
  }, [settings]);

  const updateLayout = (key, value) => {
    dispatch({
      type: ACTIONS.UPDATE_LAYOUT,
      key,
      value,
    });
  };

  const updateText = (key, value) => {
    dispatch({
      type: ACTIONS.UPDATE_TEXT,
      key,
      value,
    });
  };

  const resetSettings = () => {
    dispatch({
      type: ACTIONS.RESET,
    });
  };

  return (
    <AccessibilityContext.Provider
      value={{
        settings,
        updateLayout,
        updateText,
        resetSettings,
      }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useAccessibility = () =>
  useContext(AccessibilityContext);